export default "__VITE_ASSET__d4256455__"